import { useState, useRef } from "react";
import { Calendar } from "./Calendar";
import {
  ContainerCalender,
  InputDateContainer,
} from "./CalendarStyle.styled";

export const CalendarComponent = ({
  value,
  onChange,
}: {
  value: Date;
  onChange: (date: Date) => void;
}) => {
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const formatDate = (date: Date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = String(date.getFullYear()).slice(-2);
    return `${day}.${month}.${year}`;
  };

  return (
    <ContainerCalender ref={containerRef}>
      <InputDateContainer
        type="text"
        readOnly
        value={formatDate(value)}
        onClick={() => setIsCalendarOpen(!isCalendarOpen)}
        style={{ cursor: "pointer" }}
      />

      {isCalendarOpen && (
        <div style={{ position: "absolute", zIndex: 1, background: "#fff" }}>
          <Calendar
            value={value}
            onChange={(newDate) => {
              onChange(newDate); // ← передаємо в батька
              setIsCalendarOpen(false);
            }}
          />
        </div>
      )}
    </ContainerCalender>
  );
};
